import { ResponseError } from '@marketplace-web/shared/api-client'
import { ResponseCode } from 'data/api/response-codes'

export const isNetworkError = (response: Record<string, unknown> | ResponseError<unknown>) => {
  if (!('errors' in response)) return false

  return response.code === 'ERR_NETWORK'
}

export const isTimeoutError = (response: Record<string, unknown> | ResponseError<unknown>) => {
  if (!('errors' in response)) return false

  return response.code === 'ETIMEDOUT'
}

export const isIdTokenInvalidError = (
  response: Record<string, unknown> | ResponseError<unknown>,
) => {
  if (!('code' in response)) return false

  return response.code === ResponseCode.IdTokenInvalid
}
